import { clearSentryUser } from "@/services/application-monitoring-adapter";
import { logout } from "@/services/core-api-adapter";
import { clearValue } from "@/store/persistence";

export function logoutAndReload() {
  return logout().then(() => {
    clearValue("isUserLoggedIn");
    clearValue("currentUser");
    clearValue("welcomeScreenLastViewed");
    clearValue("redirectLink");
    clearSentryUser();
    window.location.replace("/");
  });
}
